import { toast } from "react-toastify";
import { makeCygnusApiCall } from "../../../api/api";

export const submitWetSignDocument = async (
  processedTemplateId: number,
  clientMasterId: number,
  clientId: string,
  clientName: string,
  fileName: string,
  file: File,
  setUploading: (val: boolean) => void,
  refresh: () => void,
  onHide: () => void
) => {
  try {
    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("ProcessedTemplateId", processedTemplateId.toString());
    formData.append("ClientMasterId", clientMasterId.toString());
    formData.append("ClientId", clientId);
    formData.append("ClientName", clientName);
    formData.append("FileName", fileName);

    const response = await makeCygnusApiCall({
      type: "POST",
      url: "/engagement-letter/wetsign_upload/",
      payload: formData,
      payload_is_file: true,
      show_message: true,
      customized_success_message: "WetSigned EL upload successful!",
      customized_failure_message:
        "Failed to upload WetSigned EL. Please try again.",
      customized_error_message:
        "Error occurred while uploading the WetSigned EL.",
      isblob: false,
      forMDM: true,
    });

    if (response?.success) {
      refresh();
      onHide();
    }
  } catch (err) {
    console.error("WetSign Upload Error:", err);
    toast.error("Unexpected error during upload.", {
      position: "bottom-right",
      autoClose: 3500,
      className: "toastify-color-error",
    });
  } finally {
    setUploading(false);
  }
};
